import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchPostsByCategory } from "../services/firestore";
import ArticleCard from "../components/ArticleCard";
import Sidebar from "../components/Sidebar";
import "./CategoryPage.css";

export default function CategoryPage() {
  const { name } = useParams();
  const category =
    name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    fetchPostsByCategory(category).then((data) => {
      setPosts(data);
      setLoading(false);
    });
  }, [category]);

  return (
    <div className="container category-layout">
      <main className="category-main">
        <div className="category-header">
          <div className="category-breadcrumb">
            <Link to="/">Home</Link> / <span>{category}</span>
          </div>
          <h1 className="category-title">{category}</h1>
          <p className="category-count">
            {loading ? "Loading..." : `${posts.length} article${posts.length !== 1 ? "s" : ""}`}
          </p>
        </div>

        {loading ? (
          <div className="category-loading">
            <div className="loading-spinner" />
            <p>Loading articles...</p>
          </div>
        ) : posts.length === 0 ? (
          <div className="category-empty">
            <p>No articles found in this category yet.</p>
            <Link to="/" className="back-home">← Back to Home</Link>
          </div>
        ) : (
          <div className="category-grid">
            {posts.map((p) => (
              <ArticleCard key={p.id} post={p} size="medium" />
            ))}
          </div>
        )}
      </main>

      <Sidebar />
    </div>
  );
}
